import React from 'react'
import { array, func, string, bool } from 'prop-types'
import classNames from 'classnames'

import MagazineIssueHighlights from '../../MagazineIssueHighlights'

import styles from '../IssueMagazineViewer.module.scss'

const MagazineViewer = ({
  isFullScreen,
  issuIssueId,
  issuPublicationId,
  page,
  highlights,
  onHighlightClick,
  magazineOrigin,
  isDesktop
}) => {
  const isMobile = !isDesktop

  return (
    <>
      <div className={styles.Wrapper}>
        {magazineOrigin === 'joomag' ? (
          <iframe
            title="Magazine viewer"
            allowFullScreen
            className={classNames(
              styles.IssueMagazineViewer,
              isFullScreen && styles.fullscreen
            )}
            src={`https://viewer.joomag.com/${issuIssueId}?e=1&page=${page}&eembedInfo=theme,293042,151b26,ffffff,ffe358,ffffff;none`}
          />
        ) : (
          <iframe
            allowFullScreen
            className={classNames(
              styles.IssueMagazineViewer,
              isFullScreen && styles.fullscreen
            )}
            title="magazineIssueViewer"
            sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox"
            src={`https://e.issuu.com/embed.html?d=${issuIssueId}&hideIssuuLogo=true${
              isMobile ? '&pageLayout=singlePage' : ''
            }&u=${issuPublicationId}&p=${page}`}
          />
        )}
      </div>
      {!isFullScreen && (
        <MagazineIssueHighlights
          highlights={highlights}
          onClick={onHighlightClick}
        />
      )}
    </>
  )
}

MagazineViewer.propTypes = {
  issuPublicationId: string,
  issuIssueId: string,
  page: string,
  highlights: array,
  onHighlightClick: func,
  isFullScreen: bool,
  magazineOrigin: string,
  isDesktop: bool
}

export default MagazineViewer
